const CONNECTION_NAME_CONTENT_PATTERN = /[\p{L}\p{N}]/u;

export const CONNECTION_NAME_MAX_LENGTH = 100;

export function getConnectionNameLength(value: string) {
  return Array.from(value).length;
}

export function hasValidConnectionNameContent(value: string) {
  return CONNECTION_NAME_CONTENT_PATTERN.test(value.trim());
}

export function isConnectionNameWithinLimit(value: string) {
  return getConnectionNameLength(value.trim()) <= CONNECTION_NAME_MAX_LENGTH;
}

export function isValidConnectionName(value: string) {
  return hasValidConnectionNameContent(value) && isConnectionNameWithinLimit(value);
}
